import { render, staticRenderFns } from "./DdCheckS.vue?vue&type=template&id=3c8af018&scoped=true&"
import script from "./DdCheckS.vue?vue&type=script&lang=js&"
export * from "./DdCheckS.vue?vue&type=script&lang=js&"
import style0 from "./DdCheckS.vue?vue&type=style&index=0&id=3c8af018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8af018",
  null
  
)

export default component.exports